/** web-studio-sites D7: what the next session's current state requires a drawing to show: View booking, once there is one. */
import type { RequiredParts } from '../../contract/required';
import type { NextSessionState } from './contract';

export const requiredParts: RequiredParts<NextSessionState> = (state) =>
  state.booking ? [{ part: 'viewBooking', action: 'open' }] : [];
